// Import source styles
import '../scss/app.scss';

// Load External Libraries
import './bootstrap';
import AOS from 'aos';
import { Fancybox } from "@fancyapps/ui";

// Local imports
import { validate } from './modules/_validate.mjs';
import { Disclosure } from "./modules/_disclosure.mjs";
import { offcanvas } from "./modules/_offcanvas.mjs";
import { headerscroll } from "./modules/_header.mjs";
import { merkenSlider } from "./modules/_carousels.mjs";

document.addEventListener("DOMContentLoaded", function () {
    AOS.init({startEvent: 'load', disable: 'mobile'});
    validate();
    offcanvas();
    headerscroll();
    merkenSlider();

    const disclosure = new Disclosure();

});
